import { __awaiter } from "tslib";
export class BaseHttpClient {
    constructor(baseUrl, callbacks, baseHeaders = {}, timeout = 30000) {
        this.onOffLineObserver = undefined;
        this.setAuthorizationHeaders = undefined;
        this.notifyXhrRequestFired = undefined;
        this.notifyError = undefined;
        this.baseHeaders = {};
        this.baseUrl = baseUrl.replace(/$^\//, "");
        this.onOffLineObserver = callbacks.onOffLineObserver;
        this.setAuthorizationHeaders = callbacks.setAuthorizationHeaders;
        this.notifyXhrRequestFired = callbacks.notifyXhrRequestFired;
        this.notifyError = callbacks.notifyError;
        this.baseHeaders = baseHeaders;
        this.timeout = timeout;
    }
    request(_a) {
        return __awaiter(this, arguments, void 0, function* ({ method, url, data, isAnonymous = false, }) {
            var _b, _c, _d;
            if (((_b = this.onOffLineObserver) === null || _b === void 0 ? void 0 : _b.getValue("isOnline")) === false) {
                this.onOffLineObserver.notify();
                return {
                    statusCode: 503,
                    code: "general:onOffLine.offline",
                    message: "The application is offline",
                    data: undefined,
                };
            }
            let headers = Object.assign({}, this.baseHeaders);
            if (this.setAuthorizationHeaders && !isAnonymous) {
                headers = Object.assign(Object.assign({}, headers), this.setAuthorizationHeaders());
            }
            if (!isAnonymous && this.notifyXhrRequestFired)
                this.notifyXhrRequestFired(isAnonymous);
            const callUrl = `${this.baseUrl}/${url
                .replace(/\/{2,4}/g, "/")
                .replace(/^\//, "")}`;
            const init = {
                method,
                headers,
                signal: AbortSignal.timeout(this.timeout),
            };
            let fetchUrl = callUrl;
            switch (method) {
                case "GET":
                    fetchUrl = appendQueryParams(callUrl, data ? { id: data } : undefined);
                    break;
                case "DELETE":
                    fetchUrl = appendQueryParams(callUrl, data);
                    break;
                case "POST":
                case "PUT":
                    if (data !== undefined) {
                        if (data instanceof FormData) {
                            init.body = data;
                        }
                        else {
                            init.body = JSON.stringify(data);
                            init.headers = Object.assign(Object.assign({}, headers), { "Content-Type": "application/json" });
                        }
                    }
                    break;
            }
            let response;
            try {
                response = yield fetch(fetchUrl, init);
            }
            catch (error) {
                // The request was made but no response was received (network failure, timeout/abort, etc.)
                console.log("Error in network request", error);
                console.log("Error request");
                (_c = this.notifyError) === null || _c === void 0 ? void 0 : _c.call(this, 400, "request", "The request was made but no response was received");
                return {
                    statusCode: 400,
                    code: "",
                    message: "Unknown error",
                    data: undefined,
                };
            }
            const body = yield parseResponseBody(response);
            if (!response.ok) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                const httpCode = response.status || 400;
                const errRes = body;
                (_d = this.notifyError) === null || _d === void 0 ? void 0 : _d.call(this, httpCode, "response", httpCode === 401 || httpCode === 403
                    ? (typeof errRes === "object" && (errRes === null || errRes === void 0 ? void 0 : errRes.message)) ||
                        "errors:notAllowed"
                    : typeof errRes === "string"
                        ? errRes
                        : (errRes === null || errRes === void 0 ? void 0 : errRes.translationKey) ||
                            (errRes === null || errRes === void 0 ? void 0 : errRes.message) ||
                            "errors:errorHasOcurred");
                return {
                    statusCode: httpCode,
                    code: typeof errRes === "object" ? errRes === null || errRes === void 0 ? void 0 : errRes.code : undefined,
                    message: (typeof errRes === "object" &&
                        ((errRes === null || errRes === void 0 ? void 0 : errRes.message) || (errRes === null || errRes === void 0 ? void 0 : errRes.translationKey))) ||
                        "Unknown error",
                    data: undefined,
                };
            }
            return {
                statusCode: response.status,
                data: body,
            };
        });
    }
}
function appendQueryParams(url, params) {
    if (!params)
        return url;
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null)
            search.append(key, String(value));
    });
    const qs = search.toString();
    if (!qs)
        return url;
    return `${url}${url.includes("?") ? "&" : "?"}${qs}`;
}
function parseResponseBody(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (response.status === 204 || response.status === 205)
            return undefined;
        const text = yield response.text();
        if (!text)
            return undefined;
        const contentType = response.headers.get("content-type") || "";
        if (!contentType.includes("application/json"))
            return text;
        try {
            return JSON.parse(text);
        }
        catch (_a) {
            return text;
        }
    });
}
export function isHttpStatusCodeSuccess(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
